<script setup lang="ts">
import type { PropType } from "vue";

const props = defineProps({
  headersNav: {
    type: Array as PropType<any[]>,
  },
  resetNav: {
    type: Number,
  },
  tabSelected: {
    type: String,
  },
  disabledNav: {
    type: Boolean,
  },
});

const emit = defineEmits(["tabNavigate"]);

function isSelected(filter: any) {
  return props.tabSelected === filter;
}

function selectNav(nav: Record<string, any>) {
  emit("tabNavigate", nav);
}

onMounted(() => {
  if (!props.tabSelected && props.headersNav) {
    const firstNav = props.headersNav?.find(Boolean);
    selectNav(firstNav);
  }
});

watch(
  () => props.resetNav,
  () => {
    const nav = props.headersNav?.find(Boolean);
    if (nav) selectNav(nav);
  },
);
</script>

<template>
  <div class="border-b-[1px] border-stroke-color flex place-content-between">
    <div class="flex flex-row container-menu w-full">
      <div
        v-for="nav in headersNav"
        :key="`key-${nav.name}`"
        class="grid_nav_button nav mx-[8px] flex-1"
        :class="{ nav_selected: isSelected(nav.name), 'cursor-pointer': !disabledNav }"
        @click="disabledNav ? null : selectNav(nav)"
      >
        <div class="grid_nav_text body_regular link" :data-border-right="nav.borderRight" :data-title="nav.title">
          {{ nav.name }}{{ nav.nb || !isNaN(nav.nb!) ? ` (${nav.nb})` : "" }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";

.nav {
  @apply gap-[24px] border-b-[1px] border-stroke-color;
}

.hidden_mobile {
  @apply hidden sm:flex;
}

.grid_nav_button {
  @apply py-[6px];
  border-bottom: 2px solid transparent;
}

.grid_nav_text {
  @apply px-[8px] py-[8px];
  text-align: center;
  line-height: 20px;
  color: var(--text-secondary-color);
  position: relative;

  &[data-border-right="true"]::after {
    content: "";
    position: absolute;
    right: -8px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: var(--grey-medium-light);
  }

  &[data-title="true"] {
    text-transform: uppercase;
    @apply body_med;
  }
}

.nav_selected {
  border-bottom: 2px solid var(--primary-blue-color);
}

.grid_nav_button:hover {
  .grid_nav_text {
    color: var(--text-main-color);
  }
}

.grid_nav_text_hiding_kpi {
  @apply flex flex-row gap-[0px] border-b-[0px] border-stroke-color;
  @apply px-[8px] py-[8px];
  padding-right: 0;
  text-align: center;
  line-height: 20px;
  color: var(--text-secondary-color);

  &[data-border-right="true"] {
    border-right: 1px solid var(--grey-medium-light);
  }
}

.show_hide {
  color: var(--primary-blue-color);
  filter: invert(50%) sepia(36%) saturate(3981%) hue-rotate(185deg) brightness(103%) contrast(105%);
}

.show_hide:hover {
  text-decoration: underline;
}

@media (max-width: "768px") {
  .container-menu {
    overflow: auto;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }

  .container-menu::-webkit-scrollbar {
    display: none;
  }

  .link {
    display: inline-block;
    text-decoration: none;
    text-align: center;
  }
}
</style>
